import type {FC, ReactElement} from 'react';
import {Helmet} from 'react-helmet';

import type {WithChildren} from '@yourcoach/shared/utils/utility-types';

import {Text} from '@yourcoach/shared/uikit/Text';

import {MainMenuLayout, TopMenuLayout} from '../../../layouts';
import NotificationTopContainer from '../../../layouts/NotificationTopContainer/NotificationTopContainer';
import {Layout} from './components/Layout';

interface Props extends WithChildren {
  fitBodyDisabled?: boolean;
  headerSlot?: ReactElement<any>;
  isScrollable?: boolean;
  isWithBreadcrumbs?: boolean;
  isWithFromBreadcrumb?: boolean;
  isWithHeader?: boolean;
  pageTitle?: string;
  skipRootCrumb?: boolean;
  titleSlot?: ReactElement<any>;
}

const PageContainer: FC<Props> = ({
  children,
  fitBodyDisabled = false,
  headerSlot,
  isScrollable = true,
  isWithBreadcrumbs,
  isWithFromBreadcrumb,
  isWithHeader = true,
  pageTitle,
  skipRootCrumb,
  titleSlot,
}) => {
  const renderHeader = () =>
    isWithHeader ? (
      <Layout.Header>
        {titleSlot ? (
          titleSlot
        ) : (
          <Text as={'h1'} variant={'h1'}>
            {pageTitle}
          </Text>
        )}
        {headerSlot}
      </Layout.Header>
    ) : null;

  return (
    <>
      <Helmet title={pageTitle} />

      <NotificationTopContainer />

      <Layout.Container isScrollable={isScrollable}>
        <MainMenuLayout />
        <Layout.Body isFitted={!fitBodyDisabled}>
          <TopMenuLayout
            isWithCrumbs={isWithBreadcrumbs}
            isWithFrom={isWithFromBreadcrumb}
            skipRootCrumb={skipRootCrumb}
          />
          {renderHeader()}
          <Layout.Content>{children}</Layout.Content>
        </Layout.Body>
      </Layout.Container>
    </>
  );
};

export {PageContainer};
